(function($) {
	if ( ESRB.autocomplete_source_url ) {
		$.getScript( ESRB.autocomplete_source_url, function( data, textStatus, jqxhr ) {
			if ( "undefined" !== typeof TitleAutocomplete ) {

				$('.esrb-autocomplete').attr('autocomplete', 'off').typeahead({
					source: TitleAutocomplete,
					autoSelect: false,
					afterSelect: function submitFormOnSelectValueFromTypeahead( value ){

						if ( !this.$element.hasClass( 'prevent-quick-submit' ) ) {
							this.$element.closest( 'form' ).submit();
						}

					},
					afterEmptySelect: function submitFormifNoneSelectedButHaveValue(){

						if ( !this.$element.hasClass( 'prevent-quick-submit' ) ) {
							if ( this.$element.val() && this.$element.is(':focus') ) {
								this.$element.closest('form').submit();
							}
						}

					}
				});

			}
		});
	}
})(jQuery);